export default class Menu {
  constructor() {
    this.menu = document.querySelector('[data-menu="overlay"]');
    this.html = document.querySelector('html');
    this.toggleMenu = this.toggleMenu.bind(this);
    this.anchorScroll = this.anchorScroll.bind(this);
    this.isMenuOpen = false;

    this.init();
  }

  init() {
    if (!this.menu) return;
    this.makeVisible();
    this.getElements();
    this.bindEvents();
  }

  makeVisible() {
    // Prevent flickering on load
    setTimeout(() => this.menu.style.display = 'block', 100);
  }

  getElements() {
    this.toggler = document.querySelector('[data-menu="toggler"]');
    this.anchor = this.menu.querySelectorAll('[data-menu="anchor"]');
  }

  bindEvents() {
    this.toggler.addEventListener('click', this.toggleMenu);
    this.anchor.forEach(a => a.addEventListener('click', this.anchorScroll));
  }

  showMenu() {
    this.isMenuOpen = true;
    this.html.classList.add('is-noscroll');
    this.toggler.classList.add('is-active');
    this.menu.classList.add('is-visible');
  }

  hideMenu() {
    this.isMenuOpen = false;
    this.html.classList.remove('is-noscroll');
    this.toggler.classList.remove('is-active');
    this.menu.classList.remove('is-visible');
  }

  toggleMenu() {
    this.isMenuOpen ? this.hideMenu() : this.showMenu();
  }

  anchorScroll(e) {
    e.preventDefault();
    let target = document.querySelector(e.currentTarget.getAttribute('href'));
    this.hideMenu();
    setTimeout(() => {
      window.scrollTo({top: target.offsetTop, behavior: 'smooth'});
    }, 10); /* Prevents chrome scrolling bug */
  }
}
